module.exports = __webpack_public_path__ + "media/images/homepage/open_rounds_white_logo-a8dd5f5591ba0e69b21be55e8a94fb51.png";